/* eslint-disable */
"use strict";

import { ODUtil } from "./../../components/util.js";
import ODLayoutContent from "./content.js";

var ODLayoutStretchedCard = function() {
    // Private properties
	var _element;

	// Private functions
	var _init = function() {
		var scroll = ODUtil.find(_element, '.card-scroll');
		var cardBody = ODUtil.find(_element, '.card-body');
		var cardHeader = ODUtil.find(_element, '.card-header');

		var height = ODLayoutContent.getHeight();

		height = height - parseInt(ODUtil.actualHeight(cardHeader));

		height = height - parseInt(ODUtil.css(_element, 'marginTop')) - parseInt(ODUtil.css(_element, 'marginBottom'));
		height = height - parseInt(ODUtil.css(_element, 'paddingTop')) - parseInt(ODUtil.css(_element, 'paddingBottom'));

		height = height - parseInt(ODUtil.css(cardBody, 'paddingTop')) - parseInt(ODUtil.css(cardBody, 'paddingBottom'));
		height = height - parseInt(ODUtil.css(cardBody, 'marginTop')) - parseInt(ODUtil.css(cardBody, 'marginBottom'));

		height = height - 3;

		ODUtil.css(scroll, 'height', height + 'px');
	}

    // Public methods
	return {
		init: function(id) {
            _element = ODUtil.getById(id);

            if (!_element) {
                return;
            }

            // Initialize
			_init();

            // Re-calculate on window resize
            ODUtil.addResizeHandler(function() {
				_init();
			});
		},

		update: function() {
			_init();
		}
	};
}();

// Webpack support
if (typeof module !== 'undefined') {
	// module.exports = ODLayoutStretchedCard;
}

export default ODLayoutStretchedCard;
